import React from 'react';
import {LEAGUE_CONFIGS} from '../../../configs/leagues';
import {getPlaceIconPath} from '../../../utils/gameEnd/getPlaceIconPath';
import {
  GLORY_HALL_DAILY_CRYSTALS,
  LEAGUE_DAILY_CRYSTALS,
  RATING_DAILY_PENALTY,
} from '../../../configs/ratingCrystals';
import './RatingCrystalsPage.css';

const PLACE_TITLES = ['1-е место', '2-е место', '3-е место'];

/**
 * Пояснение к странице: за что вообще капают кристаллы за рейтинг.
 * Оформлено как содержимое модалки начислений — те же строки «причина +N
 * кристаллов», те же значки лиг и мест. Все числа берутся из конфига, по
 * которому начисляет сервер, поэтому расходиться с реальностью не могут.
 */
export const RatingCrystalsInfo = ({className = '', withTitle = true}) => {
  const leagueRows = LEAGUE_CONFIGS
    .filter((league) => LEAGUE_DAILY_CRYSTALS[league.id])
    .map((league) => ({
      key: league.id,
      icon: league.iconPath,
      iconClassName: 'rating-crystals-row_league-icon rating-crystals-row_league-icon-info',
      title: league.name,
      crystals: LEAGUE_DAILY_CRYSTALS[league.id],
    }));

  const gloryRows = GLORY_HALL_DAILY_CRYSTALS.map((crystals, index) => ({
    key: `place_${index}`,
    icon: getPlaceIconPath(index),
    iconClassName: 'rating-crystals-row_place-icon',
    title: `${PLACE_TITLES[index]}`,
    crystals,
  }));

  const renderRow = (row) => (
    <span className={'rating-crystals-row_reason'} key={row.key}>
      <img className={row.iconClassName} src={row.icon} alt={row.title}/>
      <span>{row.title}</span>
      <span className={'text-crystals rating-crystals-info_amount'}>
        +{row.crystals}
        <img
          className={'rating-crystals-info_crystal-icon'}
          src={'/img/icons/crystal.png'}
          alt={'Кристаллы'}
        />
      </span>
    </span>
  );

  return (
    <div className={`rating-crystals-info ${className}`}>
      {/* В модалке знакомства заголовок свой, выше картинки — там этот не нужен */}
      {withTitle && (
        <h2 className={'rating-crystals-info_title'}>За что начисляются кристаллы</h2>
      )}

      {/* Суть механики одной фразой — и на странице, и в модалке знакомства */}
      <p className={'rating-crystals-info_lead'}>
        Все игроки <span className={'text-coins'}>Золотой лиги и выше</span>
        <br/><span className={'text-crystals'}>каждый день</span> получают{' '}
        <span className={'text-crystals'}>кристаллы</span> за свой рейтинг — просто за то, что держатся наверху.
      </p>

      <div className={'rating-crystals-info_group'}>
        <h3 className={'rating-crystals-info_subtitle text-coins'}>За лигу</h3>
        <div className={'rating-crystals-row_reasons'}>
          {leagueRows.reverse().map(renderRow)}
        </div>
      </div>

      <div className={'rating-crystals-info_group'}>
        <h3 className={'rating-crystals-info_subtitle text-coins'}>За место в Зале славы</h3>
        <div className={'rating-crystals-row_reasons'}>
          {gloryRows.map(renderRow)}
        </div>
      </div>

      <p className={'rating-crystals-info_note'}>
        Награда приходит каждый день в конце игровых суток. Кристаллы за лигу и за место
        в Зале славы складываются.
      </p>

      <p className={'rating-crystals-info_note rating-crystals-info_note--warning'}>
        У всех, кто получает награду за лигу, в этот же момент списывается
        {' '}<span className={'text-rating'}>{RATING_DAILY_PENALTY} рейтинга</span> — удержаться
        в лиге можно только победами.
      </p>
    </div>
  );
};

export default RatingCrystalsInfo;
